import angular from 'angular';
import { get } from 'lodash';

import '../app.constants';
import './connection';
import './notifications';

const module = angular.module('whyline.services.errors', [
  'whyline.services.notifications',
  'whyline.services.connection',
]);

const ErrorService = (NotificationService, $translate) => {
  'ngInject';

  const KnowErrors = [
    'queue.subscribe.line-not-found-in-area',
    'queue.call-to.somebody-is-processing',
    'queue.call-to.not-found',
    'queue.call-next.somebody-is-processing',
    'queue.call-next.not-found',
    'queue.subscribe.queue-close',
    'queue.subscribe.daily-limit-reached',
    'queue.forward.area-closed',
    'appointment.too-late',
    'appointment.too-early',
    'appointment.already-canceled',
    'appointment.already-checked-in',
    'appointment.cannot-checked-in',
    'appointment.csv-file-not-found',
    'appointment.incorrect-number-of-headers',
    'appointment.cant-map-headers',
    'appointment-cant-map-data',
    'appointment.no-area-found',
    'appointment.cant-save',
    'appointment.not-found',
    'appointment.cron-service-error',
    'appointment.all-appointments-already-saved',
    'appointment.missing-required-value',
    'appointment.create.slot-reserved',
    'appointment.max-appointments-by-person',
    'appointment.export-csv-invalid-date',
    'appointment.create.not-enough-slots',
    'area.cant-change-configuration-because-appointments-exists',
    'area.cant-decrease-slots-configuration-because-appointments-exists',
    'area.duplicated-serviceId-in-place',
    'area.invalid-date',
    'line.remove.line-exists-in-areas',
    'login.user-disabled',
    'call-logic.cannot_delete_default_logic',
    'call-logic.cannot_enable_default_logic',
    'call-logic.cannot_disable_default_logic',
    'call-logic.duplicated_name',
    'call-logic.not_found',
    'user.login.incorrect-password',
    'user.not-found',
    'users.sign-up.email-already-registered',
    'users.sign-in.invalid-email',
    'place.create.google-place-id-already-taken',
    'place.name-already-in-use',
    'video.already-saved-name',
    'video.already-saved-src',
    'video.empty-data',
    'organization.custom-fields.duplicate-name',
    'organization.slug-not-unique',
    'organization-user.already-saved-user-email',
    'organization-area.serviceId-duplicated',
    'connect-wizard.duplicated-email',
    'connect-wizard.duplicated_api_client_key',
    'plan.limit-reached',
    'connect-wizard.connect-service-not-available',
    'holiday.invalid-date.exists-appointments-in-range-of-days',
    'holiday.invalid-period.to-must-be-greater-or-equal-than-from',
    'holiday.invalid-period.to-hour-must-be-greater-or-equal-than-from-hour',
    'holiday.invalid-from-date.can-not-be-in-the-past',
    'segment.name-already-exists',
    'scenario.name-already-exists',
    'callnext.segments.invalid-configuration',
    'place.metadata-not-found',
  ];

  function generic(error) {
    let algo_mal = $translate.instant('default_case');
    return NotificationService.Error(algo_mal + ` \n ${error}`);
  }

  function message(msj) {
    return function (error) {
      return NotificationService.Error(
        `${msj}
        ${error}`,
        'Error',
      );
    };
  }

  function handler(error) {
    if (get(error.data, 'message', false)) error.data = error.data.message;

    switch (error.data) {
      case 'queue.call-to.somebody-is-processing':
      case 'queue.call-next.somebody-is-processing':
        return NotificationService.Error(
          $translate.instant('queue.call-next.somebody-is-processing'),
        );
      case 'queue.subscribe.queue-close':
        return NotificationService.Error($translate.instant('queue.subscribe.queue-close'));
      case 'queue.subscribe.daily-limit-reached':
        return NotificationService.Error($translate.instant('queue.subscribe.daily-limit-reached'));
      case 'queue.subscribe.line-not-found-in-area':
        return NotificationService.Error(
          $translate.instant('queue.subscribe.line-not-found-in-area'),
        );
      case 'queue.forward.area-closed':
        return NotificationService.Error($translate.instant('queue.forward.area-closed'));
      case 'queue.call-next.not-found':
        return NotificationService.Error($translate.instant('queue.call-next.not-found'));
      case 'queue.call-to.not-checked-in':
        return NotificationService.Error($translate.instant('queue.call-to.not-checked-in'));
      case 'queue.operator.not-ready':
        return NotificationService.Error($translate.instant('queue.operator.not-ready'));
      case 'queue.operator.has-no-subscriptions-to-call':
        return NotificationService.Error($translate.instant('queue.operator.has-no-subscriptions-to-call'));
      case 'queue.call-next.not-found':
        return NotificationService.Error($translate.instant('queue.call-next.not-found'));
      case 'appointment.already-canceled':
        return NotificationService.Error($translate.instant('appointment.already-canceled'));
      case 'appointment.create.slot-reserved':
        return NotificationService.Error($translate.instant('appointment.create.slot-reserved'));
      case 'appointment.too-late':
        return NotificationService.Error($translate.instant('appointment.too-late'), {
          timeOut: 10000,
        });
      case 'appointment.too-early':
        let translated = $translate.instant('appointment.too-early', { minutes: error.checkInMin }),
          come_back_at = $translate.instant('appointment.too-early-comeback');

        if (error.comeBackAt) {
          return NotificationService.Error(`${translated} ${come_back_at} ${error.comeBackAt}.`, {
            timeOut: 10000,
          });
        } else {
          return NotificationService.Error(translated, { timeOut: 10000 });
        }
      case 'appointment.cannot-checked-in':
      case 'appointment.already-checked-in':
        return NotificationService.Error($translate.instant('appointment.already-checked-in'));
      case 'appointment.csv-file-not-found':
        return NotificationService.Error($translate.instant('appointment.csv-file-not-found'));
      case 'appointment.incorrect-number-of-headers':
        return NotificationService.Error(
          $translate.instant('appointment.incorrect-number-of-headers'),
        );
      case 'appointment.cant-map-headers':
        return NotificationService.Error($translate.instant('appointment.cant-map-headers'));
      case 'appointment-cant-map-data':
        return NotificationService.Error($translate.instant('appointment-cant-map-data'));
      case 'appointment.no-area-found':
        return NotificationService.Error($translate.instant('appointment.no-area-found'));
      case 'appointment.cant-save':
        return NotificationService.Error($translate.instant('appointment.cant-save'));
      case 'appointment.not-found':
        return NotificationService.Error($translate.instant('appointment.not-found'));
      case 'appointment.can-no-longer-be-edited':
        return NotificationService.Error($translate.instant('appointment.can-no-longer-be-edited'));
      case 'appointments_from_date_greater_than_to_date':
        return NotificationService.Error(
          $translate.instant('appointments_from_date_greater_than_to_date'),
        );
      case 'appointment.cron-service-error':
        return NotificationService.Warning($translate.instant('appointment.cron-service-error'));
      case 'appointment.all-appointments-already-saved':
        return NotificationService.Warning(
          $translate.instant('appointment.all-appointments-already-saved'),
        );
      case 'appointment.cancel.appointment-already-processed':
        return NotificationService.Warning(
          $translate.instant('appointment.cancel.appointment-already-processed'),
        );
      case 'appointment.max-appointments-by-person':
        return NotificationService.Warning(
          $translate.instant('appointment.max-appointments-by-person'),
        );
      case 'area.cant-change-configuration-because-appointments-exists':
        return NotificationService.Error(
          $translate.instant('area.cant-change-configuration-because-appointments-exists'),
        );
      case 'area.cant-decrease-slots-configuration-because-appointments-exists':
        return NotificationService.Error(
          $translate.instant('area.cant-decrease-slots-configuration-because-appointments-exists', {
            currentSlotConfiguration: error.context.currentSlotConfiguration,
          }),
        );
      case 'area.duplicated-serviceId-in-place':
        return NotificationService.Error($translate.instant('area.duplicated-serviceId-in-place'));
      case 'area.invalid-date':
        return NotificationService.Error($translate.instant('appointments_old_date'));
      case 'line.remove.line-exists-in-areas':
        return NotificationService.Error($translate.instant('line.remove.line-exists-in-areas'));
      case 'login.user-disabled':
        return NotificationService.Error($translate.instant('login_user_disabled'));
      case 'call-logic.cannot_delete_default_logic':
        return NotificationService.Error(
          $translate.instant('call-logic.cannot_delete_default_logic'),
        );
      case 'call-logic.cannot_enable_default_logic':
        return NotificationService.Error(
          $translate.instant('call-logic.cannot_enable_default_logic'),
        );
      case 'call-logic.cannot_disable_default_logic':
        return NotificationService.Error(
          $translate.instant('call-logic.cannot_disable_default_logic'),
        );
      case 'call-logic.duplicated_name':
        return NotificationService.Error($translate.instant('call_logic_name_duplicated'));
      case 'call-logic.not_found':
        return NotificationService.Error($translate.instant('call-logic.not_found'));
      case 'users.sign-up.email-already-registered':
      case 'connect-wizard.duplicated-email':
        return NotificationService.Error(
          $translate.instant('users.sign-up.email-already-registered'),
        );
      case 'user.login.incorrect-password':
        return NotificationService.Error($translate.instant('user.login.incorrect-password'));
      case 'user.not-found':
        return NotificationService.Error($translate.instant('user.not-found'));
      case 'place.create.google-place-id-already-taken':
        return NotificationService.Error(
          $translate.instant('place.create.google-place-id-already-taken'),
        );
      case 'place.create.branch-id-already-taken':
        return NotificationService.Error(
          $translate.instant('place.create.branch-id-already-taken'),
        );
      case 'place.name-already-in-use':
        return NotificationService.Error($translate.instant('place.name-already-in-use'));
      case 'video.already-saved-src':
        return NotificationService.Error($translate.instant('video.already-saved-src'));
      case 'video.already-saved-name':
        return NotificationService.Error($translate.instant('video.already-saved-name'));
      case 'video.empty-data':
        return NotificationService.Error($translate.instant('video.empty-data'));
      case 'schedule_export_csv_max_range':
        return NotificationService.Error($translate.instant('schedule_export_csv_max_range'));
      case 'subscription.no-requeue-status-allowed':
        return NotificationService.Error(
          $translate.instant('subscription.no-requeue-status-allowed'),
        );
      case 'organization.custom-fields.duplicate-name':
        return NotificationService.Error(
          $translate.instant('organization.custom-fields.duplicate-name'),
        );
      case 'organization.slug-not-unique':
        return NotificationService.Error($translate.instant('organization.slug-not-unique'));
      case 'not-authorized':
        return NotificationService.Error($translate.instant('not-authorized'));
      case 'organization-user.already-saved-user-email':
        return NotificationService.Error(
          $translate.instant('organization-user.already-saved-user-email'),
        );
      case 'organization-area.serviceId-duplicated':
        return NotificationService.Error(
          $translate.instant('organization-area.serviceId-duplicated'),
        );
      case 'users.sign-in.invalid-email':
        return NotificationService.Error($translate.instant('users.sign-in.invalid-email'));
      case 'connect-wizard.duplicated_api_client_key':
        return NotificationService.Error(
          $translate.instant('connect-wizard.duplicated_api_client_key'),
        );
      case 'plan.limit-reached':
        return NotificationService.Error($translate.instant('plan.limit-reached'));
      case 'connect-wizard.connect-service-not-available':
        return NotificationService.Error(
          $translate.instant('connect-wizard.connect-service-not-available'),
        );
      case 'holiday.invalid-date.exists-appointments-in-range-of-days':
        return NotificationService.Error(
          $translate.instant('holiday.invalid-date.exists-appointments-in-range-of-days'),
        );
      case 'holiday.invalid-from-date.can-not-be-in-the-past':
        return NotificationService.Error(
          $translate.instant('holiday.invalid-from-date.can-not-be-in-the-past'),
        );
      case 'holiday.invalid-period.to-must-be-greater-or-equal-than-from':
        return NotificationService.Error(
          $translate.instant('second_period_must_be_greater_than_first_one'),
        );
      case 'holiday.invalid-period.to-hour-must-be-greater-or-equal-than-from-hour':
        return NotificationService.Error(
          $translate.instant('second_period_hour_must_be_greater_than_first_one'),
        );
      case 'segment.name-already-exists':
        return NotificationService.Error($translate.instant('segment.name-already-exists'));
      case 'scenario.name-already-exists':
        return NotificationService.Error($translate.instant('scenario.name-already-exists'));
      case 'scenario.weight-already-exists':
        return NotificationService.Error($translate.instant('scenario.weight-already-exists'));
      case 'invalid_place_id':
        return NotificationService.Error($translate.instant('invalid_place_id'));
      case 'place-has-no-lines':
        return NotificationService.Error($translate.instant('place-has-no-lines'));
      case 'callnext.segments.invalid-configuration':
        return NotificationService.Error(
          $translate.instant('callnext.segments.invalid-configuration'),
        );
      case 'child "name" fails because ["name" length must be less than or equal to 50 characters long]':
        return NotificationService.Error($translate.instant('segments_length_error'));
      case 'orgnization.must-have-default-scenario':
        return NotificationService.Error(
          $translate.instant('orgnization.must-have-default-scenario'),
        );
      case 'place.metadata-not-found':
        return NotificationService.Error($translate.instant('place.metadata-not-found'));
      case 'capacity_overflow':
        return NotificationService.Error($translate.instant('capacity_overflow'));
      case 'appointment.create.not-enough-slots':
        return NotificationService.Error($translate.instant('not_enough_slots'));
      case 'tag-group.name-already-exists':
        return NotificationService.Error($translate.instant('tag-group.name-already-exists'));
      case 'tag-group.order-already-exists':
        return NotificationService.Error($translate.instant('tag-group.order-already-exists'));
      default:
        return NotificationService.Error($translate.instant('default_case'));
    }
  }

  return {
    handler,
    generic,
    message,
    KnowErrors,
  };
};

module.exports = module.service('ErrorService', ErrorService);
